import React from 'react';
import { PokemonCard, UserCard } from '../../types/pokemon';
import { UserCollectionCardItem } from './UserCollectionCardItem';

interface UserCollectionCardGridProps {
  cards: PokemonCard[];
  loading: boolean;
  collection: Record<number, UserCard>;
  onCardClick?: (card: PokemonCard) => void;
  className?: string;
}

export function UserCollectionCardGrid({
  cards,
  loading,
  collection,
  onCardClick,
  className
}: UserCollectionCardGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="bg-gray-100 rounded-xl aspect-[3/4] animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
        {cards.map((card) => {
          const userCard = collection?.[card.id] || { quantity: 0, wanted: false, tradable: false };
          
          return (
            <div key={card.id} className="relative">
              <UserCollectionCardItem
                card={card}
                quantity={userCard.quantity}
                onClick={() => onCardClick?.(card)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
} 